import { render, staticRenderFns } from "./resourceClassificationManagement.vue?vue&type=template&id=8a902f66&scoped=true&"
import script from "./resourceClassificationManagement.vue?vue&type=script&lang=js&"
export * from "./resourceClassificationManagement.vue?vue&type=script&lang=js&"
import style0 from "./resourceClassificationManagement.vue?vue&type=style&index=0&id=8a902f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a902f66",
  null
  
)

export default component.exports